import { AxiosResponse } from 'axios'
import { get, post } from '../../utils/api'
import fetchProgress from 'fetch-progress'

export const fetchRandomWork = (): Promise<AxiosResponse> =>
  get('/contests/reviews/works', {
    include: [
      'user',
      'userCount',
      'user.profile',
      'contest',
      'contestCount',
      'nomination',
      'nominationCount',
      'ageCategory',
      'ageCategoryCount',
      'attachments',
      'attachmentsCount',
      'answers',
      'answersCount',
      'answers.contestField',
      'reviews',
      'reviewsCount',
    ].join(','),
  })

export const fetchCriteries = (
  contest_id: string,
  nomination_id: string
): Promise<AxiosResponse> =>
  get(`/contests/${contest_id}/nominations/${nomination_id}/criteria`)

export const sendWorkReview = (
  userContestId: string,
  criteries: { criterion_id: string; point_value: number }
): Promise<AxiosResponse> =>
  post('/contests/reviews/works', {
    user_contest_id: userContestId,
    criteria: criteries,
  })

export const fetchWork = (work_id: string): Promise<AxiosResponse> =>
  get(`/contests/reviews/works/${work_id}`, {
    include: [
      'user',
      'userCount',
      'user.profile',
      'contest',
      'contestCount',
      'nomination',
      'nominationCount',
      'ageCategory',
      'ageCategoryCount',
      'attachments',
      'attachmentsCount',
      'answers',
      'answersCount',
      'answers.contestField',
      'reviews',
      'reviewsCount',
      'currentExpertReview',
    ].join(','),
  })

export const downloadFile = (
  uri: string,
  name: string,
  onProgress: (percent: number) => void
) =>
  fetch(uri, { cache: 'no-cache' })
    .then(
      fetchProgress({
        onProgress(progress) {
          onProgress(progress.percentage)
        },
      })
    )
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
